import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const logout = () => {
    return new Promise((resolve, reject) => {
        let email = window.localStorage.getItem('email');
        let jwtToken = window.localStorage.getItem('jwtToken');
        let loginToken = window.localStorage.getItem('loginToken');

        var fdd = new FormData;
		fdd.append('email', email);
		fdd.append('loginToken', loginToken);
		// iOS: only this device stops getting the account's pushes (Android can't name its token)
		if (typeof window.iosFCMToken === 'string' && window.iosFCMToken.trim()) {
			fdd.append('fcmToken', window.iosFCMToken.trim());
		}

        axios({
          method : "POST",
          url :  api_url + "/UserLogout",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                window.localStorage.clear();
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}